import React from 'react';
import Switch from '../../../../uiToolkit/Inputs/Switch';
import Button from '../../../../uiToolkit/Buttons/Button';
import {Icon} from '../../../../uiToolkit/Icon/Icon';
import {orgDataFormText} from '../../../../forms/OrgDataForm/orgDataFormText';
import {settingsText} from '../../settingsText';
import styles from './AppSettingsUI.module.css';

interface Props {
  hideCourseIcons: boolean;
  setHideCourseIcons: (value: boolean) => void;
  onSave: () => void;
  isLoading: boolean;
  canSave: boolean;
}

const AppSettingsUI = React.memo(
  ({
    hideCourseIcons,
    setHideCourseIcons,
    onSave,
    isLoading,
    canSave,
  }: Props) => (
    <div className={styles.container}>
      <h2 className={styles.title}>{settingsText.appSettingsTitle}</h2>
      <p className={styles.subtitle}>{settingsText.appSettingsSubtitle}</p>

      <p className={styles.sectionTitle}>
        {orgDataFormText.learnerAppSettings}
      </p>
      <div className={styles.setting}>
        <div className={styles.settingInfo}>
          <p className={styles.settingTitle}>
            {orgDataFormText.courseIconsTitle}
          </p>
          <p className={styles.settingSubtitle}>
            {orgDataFormText.courseIconsSubtitle}
          </p>
          <div className={styles.settingHint}>
            <Icon name="editor_info_ic.svg" className={styles.hintIcon} />
            <span>{orgDataFormText.courseIconsHint}</span>
          </div>
        </div>
        <Switch
          value={!hideCourseIcons}
          disabled={false}
          onToggle={() => setHideCourseIcons(!hideCourseIcons)}
        />
      </div>

      <div className={styles.actions}>
        <Button
          title={settingsText.save}
          onClick={onSave}
          isLoading={isLoading}
          disabled={!canSave}
        />
      </div>
    </div>
  ),
);

export default AppSettingsUI;
